import { Badge, makeStyles, tokens } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  legendSection: {
    backgroundColor: tokens.colorNeutralBackground1,
    borderRadius: tokens.borderRadiusLarge,
    padding: tokens.spacingVerticalL,
    marginBottom: tokens.spacingVerticalXL,
    boxShadow: tokens.shadow8,
    border: `1px solid ${tokens.colorNeutralStroke1}`
  },
  legendTitle: {
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    marginBottom: tokens.spacingVerticalM,
    color: tokens.colorNeutralForeground1
  },
  legendGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: tokens.spacingVerticalM
  },
  legendCategory: {
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacingVerticalS
  },
  legendCategoryTitle: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground2,
    marginBottom: tokens.spacingVerticalXS
  },
  legendItem: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalS,
    fontSize: tokens.fontSizeBase200
  }
});

export const RequestsLegend = () => {
  const { t } = useTranslation("requestsPage");
  const styles = useStyles();

  return (
    <div className={styles.legendSection}>
      <div className={styles.legendTitle}>{t("legend.title")}</div>
      <div className={styles.legendGrid}>
        {/* Statut de la demande */}
        <div className={styles.legendCategory}>
          <div className={styles.legendCategoryTitle}>{t("legend.requestStatus.title")}</div>
          <div className={styles.legendItem}>
            <Badge appearance="filled" color="warning">
              {t("statusBadges.pending")}
            </Badge>
            <span>{t("legend.requestStatus.pending")}</span>
          </div>
          <div className={styles.legendItem}>
            <Badge appearance="filled" color="success">
              {t("statusBadges.approved")}
            </Badge>
            <span>{t("legend.requestStatus.approved")}</span>
          </div>
          <div className={styles.legendItem}>
            <Badge appearance="filled" color="informative">
              {t("statusBadges.creatingTeam")}
            </Badge>
            <span>{t("legend.requestStatus.creatingTeam")}</span>
          </div>
          <div className={styles.legendItem}>
            <Badge appearance="filled" color="success">
              {t("statusBadges.created")}
            </Badge>
            <span>{t("legend.requestStatus.created")}</span>
          </div>
          <div className={styles.legendItem}>
            <Badge appearance="filled" color="success">
              {t("statusBadges.completed")}
            </Badge>
            <span>{t("legend.requestStatus.completed")}</span>
          </div>
          <div className={styles.legendItem}>
            <Badge appearance="filled" color="danger">
              {t("statusBadges.rejected")}
            </Badge>
            <span>{t("legend.requestStatus.rejected")}</span>
          </div>
          <div className={styles.legendItem}>
            <Badge appearance="filled" color="danger">
              {t("statusBadges.failed")}
            </Badge>
            <span>{t("legend.requestStatus.failed")}</span>
          </div>
          <div className={styles.legendItem}>
            <Badge appearance="filled" color="subtle">
              {t("statusBadges.cancelled")}
            </Badge>
            <span>{t("legend.requestStatus.cancelled")}</span>
          </div>
        </div>

        {/* État Teams */}
        <div className={styles.legendCategory}>
          <div className={styles.legendCategoryTitle}>{t("legend.teamsStatus.title")}</div>
          <div className={styles.legendItem}>
            <Badge appearance="tint" color="success" style={{ whiteSpace: "nowrap" }}>
              {t("teamsStatusBadges.provisioned")}
            </Badge>
            <span>{t("legend.teamsStatus.provisioned")}</span>
          </div>
          <div className={styles.legendItem}>
            <Badge appearance="tint" color="warning" style={{ whiteSpace: "nowrap" }}>
              {t("teamsStatusBadges.pending")}
            </Badge>
            <span>{t("legend.teamsStatus.pending")}</span>
          </div>
          <div className={styles.legendItem}>
            <Badge appearance="outline" style={{ whiteSpace: "nowrap" }}>
              {t("teamsStatusBadges.approval")}
            </Badge>
            <span>{t("legend.teamsStatus.approval")}</span>
          </div>
          <div className={styles.legendItem}>
            <Badge appearance="tint" color="danger" style={{ whiteSpace: "nowrap" }}>
              {t("teamsStatusBadges.failed")}
            </Badge>
            <span>{t("legend.teamsStatus.failed")}</span>
          </div>
          <div className={styles.legendItem}>
            <Badge appearance="outline" style={{ whiteSpace: "nowrap" }}>
              {t("teamsStatusBadges.notApplicable")}
            </Badge>
            <span>{t("legend.teamsStatus.notApplicable")}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
